import { render, staticRenderFns } from "./Estates&Trusts.vue?vue&type=template&id=4771eeac&scoped=true&"
import script from "./Estates&Trusts.vue?vue&type=script&lang=ts&"
export * from "./Estates&Trusts.vue?vue&type=script&lang=ts&"
import style0 from "./Estates&Trusts.vue?vue&type=style&index=0&id=4771eeac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4771eeac",
  null
  
)

export default component.exports